<modal (close)="onCancel()" data-testid="modal">
  <modal-header>
    <h2 class="details__title" data-testid="modal-title">
      {{ title }}
    </h2>
    <p *ngIf="subtitle">{{subtitle}}</p>
  </modal-header>
  <modal-content>
    <ng-content select="app-details-content"></ng-content>
  </modal-content>
  <modal-footer>
    <div class="footer__content">
      <div class="content__left">
        <lds-button *ngIf="showBack" appearance="default" (click)="onBack()">
          {{ backLabel }}
        </lds-button>
      </div>

      <div class="content__right">
        <span *ngIf="isInvalid()" class="details__warning">{{ warningMessage }}</span>
    
        <lds-button appearance="default" (click)="onCancel()" data-testid="modal-cancel-button">
          {{ cancelLabel }}
        </lds-button>

        <lds-button *ngIf="showNext" [appearance]="buttonStyle" (click)="onNext()" data-testid="modal-next-button">
          {{ nextLabel }}
        </lds-button>
    
        <lds-button *ngIf="showSave" [isDisabled]="!isDirty()" [appearance]="buttonStyle" (click)="onSave()" data-testid="modal-save-button">
          {{ saveLabel }}
        </lds-button>

      </div>
    </div>

  </modal-footer>
</modal>
